import React from 'react';
import { Field } from "redux-form";

import './DifficultyLevelChoice.css'

import {
    DIFFICULTY_KIDS,
    DIFFICULTY_PLAIN_SIGHT,
    DIFFICULTY_EASY,
    DIFFICULTY_MODERATE,
    DIFFICULTY_GENIUS, DIFFICULTY
} from "../../constants/Game";

export const DifficultyLevelChoice = ( props ) => {

    const { difficultyLevel, onChange, isShort } = props;


    const kidsShortExplanation = "Easy and for kids under 12.";
    const kidsLongExplanation = "Specifically written for kids under 12.  Easy and holds attention.";
    const kidsExplanation = isShort
            ? kidsShortExplanation
            : kidsLongExplanation;

    const plainSightShortExplanation = "The answers are in plain sight and obvious.";
    const plainSightLongExplanation = "The answers are in plain sight and obvious to find, "
                                + "so that this hunt is about walking from place to place (exploring) "
                                + "and easily seeing and entering the next answer code. "
                                + "E.g. \" The color of the 'Welcome' sign at the bottom of the steps at the beach\"";
    const plainSightExplanation = isShort
        ? plainSightShortExplanation
        : plainSightLongExplanation;

    const easyShortExplanation = "Not in plain sight, but not difficult.";
    const easyLongExplanation = "Not in plain sight, but not difficult.  E.g “Near the lowest point of the path, "
                                + "a piece of tape is affixed underneath the handrail — find it for the answer!”";
    const easyExplanation = isShort
        ? easyShortExplanation
        : easyLongExplanation;

    const moderateShortExplanation = "Getting difficult; requires problem solving.";
    const moderateLongExplanation = "Starting to get difficult; requires looking around, searching, thinking and a little problem solving by adults.";
    const moderateExplanation = isShort
        ? moderateShortExplanation
        : moderateLongExplanation;

    const geniusShortExplanation = "Requires expert problem solving and searching.";
    const geniusLongExplanation = "Difficult; requires lots of problem solving and/or serious looking around to find a hidden object.";
    const geniusExplanation = isShort
        ? geniusShortExplanation
        : geniusLongExplanation;

    const levelExplanation = difficultyLevel === DIFFICULTY_KIDS
        ? kidsExplanation
        : difficultyLevel === DIFFICULTY_PLAIN_SIGHT
            ? plainSightExplanation
            : difficultyLevel === DIFFICULTY_EASY
                ? easyExplanation
                : difficultyLevel === DIFFICULTY_MODERATE
                    ? moderateExplanation
                    : difficultyLevel === DIFFICULTY_GENIUS
                        ? geniusExplanation
                        : "";

    return (
        <div className="form-group row">
            <label htmlFor="isPublic" className="col-sm-2 col-form-label">Difficulty</label>
            <div className="col-sm-9">
                <div>
                    <Field
                        name={DIFFICULTY}
                        component="input"
                        type="radio"
                        checked={difficultyLevel === DIFFICULTY_KIDS}
                        onChange={onChange}
                        value={DIFFICULTY_KIDS}
                    />
                    <label className="left-margin set-width-96" htmlFor={DIFFICULTY}>
                        Kids
                    </label>
                </div>
                <div>
                    <Field
                        name={DIFFICULTY}
                        component="input"
                        type="radio"
                        checked={difficultyLevel === DIFFICULTY_PLAIN_SIGHT}
                        onChange={onChange}
                        value={DIFFICULTY_PLAIN_SIGHT}
                    />
                    <label className="left-margin set-width-96" htmlFor={DIFFICULTY}>
                        Plain sight
                    </label>
                </div>
                <div>
                    <Field
                        name={DIFFICULTY}
                        component="input"
                        type="radio"
                        checked={difficultyLevel === DIFFICULTY_EASY}
                        onChange={onChange}
                        value={DIFFICULTY_EASY}
                    />
                    <label className="left-margin set-width-96" htmlFor={DIFFICULTY}>
                        Easy
                    </label>
                </div>
                <div>
                    <Field
                        name={DIFFICULTY}
                        component="input"
                        type="radio"
                        checked={difficultyLevel === DIFFICULTY_MODERATE}
                        onChange={onChange}
                        value={DIFFICULTY_MODERATE}
                    />
                    <label className="left-margin set-width-96" htmlFor={DIFFICULTY}>
                        Moderate
                    </label>
                </div>
                <div>
                    <Field
                        name={DIFFICULTY}
                        component="input"
                        type="radio"
                        checked={difficultyLevel === DIFFICULTY_GENIUS}
                        onChange={onChange}
                        value={DIFFICULTY_GENIUS}
                    />
                    <label className="left-margin set-width-96" htmlFor={DIFFICULTY}>
                        Genius
                    </label>
                </div>
                <p className="secondary-text">{levelExplanation}</p>
            </div>
        </div>
    )
};



// WEBPACK FOOTER //
// ./src/components/huntcomponents/DifficultyLevelChoice.js